import {
  anchorName,
  triggerWords,
  type Sequence,
  type Touch,
} from "src/modules/engagement/components/phases/emailSms/emailSmsTypes";

export const PRACTICES =
  "One column, about 600px wide. One primary call to action above the fold. Subject and preheader that work together (preheader 40 to 90 characters). Logo header, alt text on every image, body text 14px or larger. A [first_name] token and a consistent sender name. Footer with the opt-out line and mailing address.";

export type CatalogMessage = {
  touch: Touch;
  sequence: Sequence;
  /** Position within its sequence, counting only its own channel. */
  touchN: number;
  trigger: string;
};

/*
    The catalog lists messages rather than sequences, because a message is the thing Ops
    opens and edits. Each row still names the sequence it belongs to: a message with no
    sequence has nothing to set its trigger against.
*/
export function catalogMessages(sequences: Sequence[]): CatalogMessage[] {
  const rows: CatalogMessage[] = [];
  sequences.forEach((sequence) => {
    const perChannel: Record<string, number> = { email: 0, sms: 0 };
    sequence.touches.forEach((touch) => {
      perChannel[touch.ch] += 1;
      rows.push({
        touch,
        sequence,
        touchN: perChannel[touch.ch],
        trigger: triggerWords(touch.days, touch.dir, anchorName(touch.anchor)),
      });
    });
  });
  return rows;
}
